import { ApiError } from '@/lib/api';

/** Mensagem amigável de erro (usa a mensagem da API quando disponível). */
export function errorMessage(err: unknown): string {
  return err instanceof ApiError ? err.message : 'Algo deu errado. Tente novamente.';
}
